<template>
  <v-layout row wrap>
    <v-col cols="12" class="py-0">
      <v-text-field
        v-validate="enableValidate || hasValues ? 'required|min:8' : ''"
        ref="password"
        v-model="password"
        :error-messages="errors.collect('password')"
        :append-icon="visible ? 'visibility' : 'visibility_off'"
        :type="visible ? 'text' : 'password'"
        :label="label"
        :suffix="password.length < 8 ? '' : 'Strength: ' + passwordMessage"
        :class="'password-gauge-' + passwordMessage"
        :outline="outline"
        data-vv-validate-on="blur"
        min="8"
        value
        data-vv-name="password"
        required
        @input="value"
        @click:append="visible = !visible"
        @keyup="resetErrorMessage"
        :loading="password"
      >
        <template v-slot:progress>
          <v-progress-linear
            :value="(passwordStrength * 100) / 5"
            :color="passwordStrength < 5 ? 'red' : 'green'"
            absolute
            height="2"
          ></v-progress-linear>
        </template>
      </v-text-field>
      <!-- <p v-if="password.length > 8">{{ 'Your password is ' + passwordMessage }}</p> -->
      <!-- :suffix="(password.length < 8) ? '' : 'Strength: ' + passwordMessage" -->
      <!-- :persistent-hint="password.length > 8" -->
      <!-- :hint="(password.length < 8) ? 'At least 8 characters' : '<span>Your password is ' + passwordMessage + '</span>'" -->
    </v-col>
    <v-col cols="12" class="py-0">
      <v-expand-transition>
        <v-layout v-if="password" class="px-2">
          <v-card flat>
            <!-- <v-icon color="error" dense>close_circle</v-icon>Atleast 10
            characters dsadsa -->
            <v-card-text v-if="this.password.length < 8" class="pa-1">
              <v-icon color="error" left>warning</v-icon>
              Minimum of 8 characters
            </v-card-text>
            <v-card-text v-if="!hasLowCase" class="pa-1">
              <v-icon color="error" left>warning</v-icon>
              Must have at least 1 lower case letter
            </v-card-text>
            <v-card-text v-if="!hasUpCase" class="pa-1">
              <v-icon color="error" left>warning</v-icon>
              Must have at least 1 upper case letter
            </v-card-text>
            <v-card-text v-if="!hasNum" class="pa-1">
              <v-icon color="error" left>warning</v-icon>
              Must have at least 1 number
            </v-card-text>
            <v-card-text v-if="!hasSpecial" class="pa-1">
              <v-icon color="error" left>warning</v-icon>
              Must have at least 1 special character (e.g !@#)
            </v-card-text>
          </v-card>
        </v-layout>
        <!-- <v-card flat>
          <v-card-text>
            <v-icon>close_circle</v-icon>Atleast 10 characters
          </v-card-text>
        </v-card> -->
      </v-expand-transition>
    </v-col>
    <v-col cols="12" class="py-0">
      <v-text-field
        v-validate="
          enableValidate || hasValues ? 'required|confirmed:password' : ''
        "
        v-model="confirmpassword"
        :error-messages="errors.collect('confirm password')"
        :append-icon="visible ? 'visibility' : 'visibility_off'"
        :type="visible ? 'text' : 'password'"
        :label="'Confirm ' + label"
        :outline="outline"
        data-vv-validate-on="blur"
        min="8"
        value
        hint="Must be the same as your password"
        data-vv-name="confirm password"
        data-vv-as="password"
        required
        @input="value"
        @click:append="visible = !visible"
        @keyup="resetErrorMessage"
      />
    </v-col>
  </v-layout>
</template>

<script>
export default {
  components: {},
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    enableValidate: {
      type: Boolean,
      default: true
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      password: '',
      confirmpassword: '',
      visible: false,
      isPasswordWeak: false
    }
  },
  computed: {
    hasValues() {
      return this.password.length > 0 || this.confirmpassword.length > 0
    },
    hasLowCase() {
      return /[a-z]/.test(this.password)
    },
    hasUpCase() {
      return /[A-Z]/.test(this.password)
    },
    hasNum() {
      return /\d/.test(this.password)
    },
    hasSpecial() {
      return /[!@#$%^&*()_+\-={};':"|,.<>?]/.test(this.password)
    },
    passwordStrength() {
      let strengthLevel = 0

      if (this.password.length > 8) strengthLevel++
      if (this.hasLowCase) strengthLevel++
      if (this.hasSpecial) strengthLevel++
      if (this.hasNum) strengthLevel++
      if (this.hasUpCase) strengthLevel++
      return strengthLevel
    },
    passwordMessage() {
      // switch (this.passwordStrength) {
      // case 2:
      // return 'too weak'
      // case 3:
      // return 'good'
      // case 4:
      // return 'strong'
      // }
      let result
      // switch (this.passwordStrength) {
      //   case 2:
      //     result = 'too weak'
      //     break
      //   case 3:
      //     result = 'good'
      //     break
      //   case 4:
      //     result = 'strong'
      //     break
      //   default:
      //     break
      // }
      let strength = this.passwordStrength
      if (strength <= 4) {
        result = 'too weak'
      } else if (strength == 5) {
        result = 'strong'
      } else {
        result = 'too weak'
      }
      return result
    }
  },
  methods: {
    reset() {
      this.password = ''
      this.confirmpassword = ''
      this.isPasswordWeak = false
      this.$validator.reset()
    },
    resetErrorMessage() {
      this.$emit('keyup')
    },
    async validate() {
      let result = await this.$validator.validateAll()
      this.value()
      return result
    },
    value() {
      let data = {
        password: this.password,
        confirmpassword: this.confirmpassword,
        isWeak: this.passwordStrength < 5,
        hasValues: this.hasValues
      }
      this.$emit('input', this.hasValues ? data : {})
      return this.hasValues ? data : {}
    }
  }
}
</script>

<style lang="scss">
.password-gauge-too {
  .v-messages__message {
    span {
      font-weight: bold;
      color: #e12963 !important;
    }
  }
  .v-text-field__suffix {
    color: #e12963 !important;
  }
}
.password-gauge-good {
  .v-messages__message {
    span {
      font-weight: bold;
      color: #b3a100 !important;
    }
  }
  .v-text-field__suffix {
    color: #b3a100 !important;
  }
}
.password-gauge-strong {
  .v-messages__message {
    span {
      font-weight: bold;
      color: #76bf43 !important;
    }
  }
  .v-text-field__suffix {
    color: #76bf43 !important;
  }
}
</style>
